// Skill + Standing registries — the progression content, mirroring shop/index.ts.
// Both the client (Skills book HUD) and the server (index.ts XP grants + unlock
// validation) import this to resolve a skill/track id to its tree/ladder. Skills
// are CONTENT: authored as JSON in content/skills/*.json + content/standing/*.json,
// validated + hydrated by src/content/load.ts. Add one = a JSON file + `bun run gen`
// (see content/SCHEMA.md) — no code edits.
import type { SkillSpec, StandingSpec } from "./define.ts";
import { loadedSkills, loadedStandings } from "../content/load.ts";

export {
  boxOf, checkBox, investedIn, scrubUnknownBoxes,
  rungNameForXp,
  fishingSum, huntingSum, cookingSum,
} from "./define.ts";
export type { SkillSpec, SkillBox, BoxStat, BoxFishing, FishingSum, BoxHunting, HuntingSum, BoxCooking, CookingSum, StandingSpec, StandingRank, BoxProgress, BoxCheck, BoxGate } from "./define.ts";

export const SKILLS: SkillSpec[] = loadedSkills;
export const STANDINGS: StandingSpec[] = loadedStandings;

/** Find a skill by id (linear scan — the list is tiny). */
export function skillById(id: string): SkillSpec | undefined {
  return SKILLS.find((s) => s.id === id);
}

/** Find a standing track by id. */
export function standingById(id: string): StandingSpec | undefined {
  return STANDINGS.find((s) => s.id === id);
}
